@if (toasts().length > 0) {
  <div class="toast-container" aria-live="polite" aria-atomic="false">
    @for (toast of toasts(); track toast.id) {
      <div class="toast"
           [class.toast--success]="toast.type === 'success'"
           [class.toast--error]="toast.type === 'error'"
           [class.toast--warning]="toast.type === 'warning'"
           [class.toast--info]="toast.type === 'info'"
           role="status">
        <div class="toast__content">
          <div class="toast__icon" [innerHTML]="getIconSvg(toast.type)" aria-hidden="true"></div>
          <span class="toast__message">{{ toast.message }}</span>
        </div>
        <button class="toast__dismiss" (click)="dismiss(toast.id)" aria-label="بستن" type="button">
          <div class="toast__dismiss-icon" [innerHTML]="getDismissIconSvg()" aria-hidden="true"></div>
        </button>
      </div>
    }
  </div>
}